import { Plus } from 'lucide-react'
import React from 'react';
import './addbutton.css';

const AddModalButton = ({ title, onClick }) => {
    return (
        <button
            title={title}
            className="btn-animated"
            onClick={onClick}
        >
            <div className="btn-content">
                <Plus size={18} />
                <span>{title}</span>
            </div>
            <div className="btn-ripple"></div>
        </button>
    )
}

export default AddModalButton